/**
 * PersistenceFailed.contract.ts — Event Contract System™ (SUPABASE FOUNDATION™).
 * A cloud persistence write failed (offline / unconfigured / server error) and
 * was queued for automatic replay. Local data is never lost — the Domain
 * Service's localStorage cache already holds the write.
 */

import type { EventContract } from '../EventContractRegistry';

export const PersistenceFailedContract: EventContract = {
  name: 'PersistenceFailed',
  version: 1,
  description: 'A cloud document write failed and was queued for replay (offline queue). Local cache retains the data; StorageManager retries on online/interval.',
  publishers: ['storage-manager'],
  subscribers: ['developer-center'],
  fields: [
    { name: 'domain', type: 'string', required: true, description: 'Document domain: profile | backpack | vault | operator' },
    { name: 'key', type: 'string', required: true, description: 'Document key within the domain' },
    { name: 'reason', type: 'string', required: true, description: 'Failure reason (network error, HTTP status, unconfigured)' },
    { name: 'queued', type: 'boolean', required: true, description: 'Always true — failed writes are queued, never dropped' },
  ],
  allowExtraFields: true,
  timestampPolicy: 'Publish time (Date.now()) at failure.',
  stability: 'stable',
  deprecated: false,
  example: { domain: 'vault', key: 'store', reason: 'network error', queued: true },
};
